import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTES } from '../constants';

export function Footer() {
  return (
    <footer className='bg-gray-900 text-gray-300 py-12'>
      <div className='container mx-auto px-6'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div>
            <h3 className='text-white text-lg font-bold mb-4'>
              <FormattedMessage
                id='footer.novoService'
                defaultMessage='NovoService'
              />
            </h3>
            <p className='text-sm'>
              <FormattedMessage
                id='footer.description'
                defaultMessage='Платформа для поиска и предложения услуг в Румынии'
              />
            </p>
          </div>
          <div>
            <h4 className='text-white font-semibold mb-4'>
              <FormattedMessage id='footer.info' defaultMessage='Информация' />
            </h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to={ROUTES.faq} className='hover:text-white'>
                  <FormattedMessage
                    id='footer.howItWorks'
                    defaultMessage='Как это работает'
                  />
                </Link>
              </li>
              <li>
                <Link
                  to={ROUTES.termsAndConditions}
                  className='hover:text-white'
                >
                  <FormattedMessage
                    id='footer.termsAndConditions'
                    defaultMessage='Условия использования'
                  />
                </Link>
              </li>
              <li>
                <Link to={ROUTES.privacy} className='hover:text-white'>
                  <FormattedMessage
                    id='footer.privacyPolicy'
                    defaultMessage='Политика конфиденциальности'
                  />
                </Link>
              </li>
              <li>
                <Link to={ROUTES.contact} className='hover:text-white'>
                  <FormattedMessage
                    id='footer.contact'
                    defaultMessage='Контакты'
                  />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className='border-t border-gray-800 mt-12 pt-8 text-sm text-center'>
          <FormattedMessage
            id='footer.rights'
            defaultMessage='© 2025 NovoService. Все права защищены.'
          />
        </div>
      </div>
    </footer>
  );
}
